import {CSSProperties} from "react";
import {EyeIcon} from "lucide-react";
import {Link} from "react-router";
import {Scene} from "@/scenes/Scene.ts";
import {Badge} from "@/components/ui/badge.tsx";
import {cn} from "@/lib/utils.ts";

export default function SceneListItem({scene, href, search, selected, displayed, style}: {
    scene: Scene;
    href: string;
    search: string;
    selected: boolean;
    displayed: boolean;
    style?: CSSProperties;
}) {
    return (
        <div style={style} className="border-b border-border bg-surface">
            <Link className={cn(
                "flex h-full items-center border-l-2 border-transparent p-1 transition-colors hover:bg-accent/65",
                selected && "border-l-warning bg-warning/10",
            )} to={{pathname: href, search}}>
                <span className="grow truncate px-3 font-medium text-foreground">{scene.name}</span>
                {displayed && <Badge className="bg-secondary"><EyeIcon/></Badge>}
            </Link>
        </div>
    );
}
